import React, { useState } from 'react';

import Footer from '../components/footer';
import { AcademicCapIcon, BriefcaseIcon, CalendarDaysIcon, ClipboardDocumentCheckIcon, SpeakerWaveIcon, UserPlusIcon, AdjustmentsHorizontalIcon, Cog6ToothIcon, ChevronRightIcon, ChevronLeftIcon, UsersIcon, ClockIcon, BanknotesIcon, PaperClipIcon, DevicePhoneMobileIcon, PlayIcon } from '@heroicons/react/24/outline';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';

const ConfigurazioneParametri = () => (
  <div>
    <p className='pt-2' style={{ textAlign: 'justify' }}>
      Inizia a gestire la tua azienda configurando le impostazioni desiderate. Personalizza i parametri nelle categorie indicate per adattare il sistema alle tue esigenze.
    </p>
    <ul className="list-disc ml-5 mt-3">
      <li className='pb-4' style={{ textAlign: 'justify' }}>
        <strong className='text-indigo-800'>Autorizzazione e Ruoli:</strong> definisci i permessi per le azioni che i tuoi dipendenti possono eseguire nella loro area personale in base al ruolo assegnato. Se inseriti in un'unità organizzativa, i dipendenti possono avere il ruolo di Gestore o Dipendente. In assenza di un ruolo assegnato, verranno considerati Dipendenti.<br />
        Per abilitare o meno un permesso ti basterà cliccare sulla casella corrispondente all’azione in questione: quando è presente la spunta ✓, vuol dire che il permesso è attivato.
        <img src={'https://consultalahr.com/wp-content/uploads/2025/01/configurazione-ruoli.png'} alt="Configurazione Autorizzazioni" className='pt-2 mx-auto w-3/4' />
      </li>
      <li className='pb-4' style={{ textAlign: 'justify' }}>
        <strong className='text-indigo-800'>Ratei:</strong> abilita i ratei che desideri utilizzare cliccando sull'azione di abilitazione. Potrai utilizzare il rateo come contatore dei residui abilitando il relativo giustificativo.
        <img src={'https://consultalahr.com/wp-content/uploads/2025/01/configurazione_ratei.png'} alt="Configurazione Ratei" className='pt-2 mx-auto w-3/4' />
      </li>
      <li className='pb-4 mt-3' style={{ textAlign: 'justify' }}>
        <strong className='text-indigo-800'>Giustificativi:</strong> nella schermata principale visualizzerai i giustificativi attivati, mentre cliccando su “Aggiungi/Modifica” si aprirà una schermata che ti permetterà di disattivarli o di abilitarne altri: per farlo, ti basterà cliccare sui pulsanti di abilitazione corrispondenti.
        Puoi anche creare giustificativi personalizzati e decidere l'azione da eseguire sulle ore lavorative collegandoli ai ratei attivi: cliccando su “+ Crea Nuovo” si aprirà una schermata dove potrai inserire il codice del giustificativo personalizzato, la descrizione, la strategia e l’eventuale frazionabilità in ore. Una volta creato il giustificativo personalizzato, questo verrà attivato in automatico e potrai modificarlo o eliminarlo in seguito dall’elenco generale dei giustificativi.
        <img src={'https://consultalahr.com/wp-content/uploads/2025/01/configurazione_giustificativi.png'} alt="Configurazione Giustificativi" className='pt-2 mx-auto w-3/4' />
      </li>
      <li className='pb-4 mt-4' style={{ textAlign: 'justify' }}>
        <strong className='text-indigo-800'>Festività:</strong> aggiungi o modifica le festività che dovranno essere presenti sul calendario. All’interno della schermata principale visualizzerai le festività attivate, che potrai modificare o eliminare cliccando sul pulsante dell’azione corrispondente, mentre per aggiungerne una nuova, ti basterà cliccare su “+ Aggiungi Nuova” ed inserire la denominazione, il giorno e il mese dell’anno: una volta salvata verrà inserita nell’elenco.
        <img src={'https://consultalahr.com/wp-content/uploads/2025/01/configurazione_festivita.png'} alt="Configurazione Festività" className='pt-3 mx-auto w-3/4' />
      </li>
      <li className='pb-4 mt-4' style={{ textAlign: 'justify' }}>
        <strong className='text-indigo-800'>Timbrature:</strong> imposta la flessibilità sugli orari di ingresso e di uscita dei tuoi dipendenti, per visualizzare sul calendario se la timbratura è avvenuta al di fuori dei limiti stabiliti. Cliccando sul tasto “Modifica”, puoi selezionare il numero di minuti per impostare i limiti di tempo per l’ingresso anticipato/posticipato e per l’uscita anticipata/posticipata: cliccando su “Salva” le impostazioni verranno quindi salvate.
        <img src={'https://consultalahr.com/wp-content/uploads/2025/01/configurazione_timbrature.png'} alt="Configurazione Timbrature" className='pt-3 mx-auto w-3/4' />
      </li>
    </ul>
  </div>
);

const AggiungiDipendenti = () => (
  <div>
    <p className='py-2' style={{ textAlign: 'justify' }}>
      Aggiungi un dipendente alla tua azienda scegliendo tra la creazione manuale, tramite compilazione del form, oppure creazione tramite il caricamento dell'Unilav.
    </p>
    <p style={{ textAlign: 'justify' }}>
      <div className='mb-4'>
        <strong className='text-indigo-800'>Creazione tramite form</strong>
        <img src={'https://consultalahr.com/wp-content/uploads/2025/01/aggiungi_dipendente_form.png'} alt="Aggiungi dipendente form" className='my-4 mx-auto w-3/4' />
        Compila i campi richiesti e inserisci l'indirizzo email del dipendente, al quale verranno inviate le credenziali di accesso alla piattaforma; una volta cliccato “Salva”, si apre una schermata di conferma della registrazione, dove, cliccando su “Sì, abilita ora”, puoi abilitare l’accesso al dipendente per l’applicazione “Consultala HR”, scaricabile su qualsiasi smartphone da Google Play e App Store. Successivamente, puoi inserire tutti i dati anagrafici e  le informazioni relative al contratto di lavoro<span className='text-indigo-600 font-semibold'>*</span> inserendo i dati richiesti all’interno della sezione “Contratto” e cliccando su “Salva”,  e puoi impostare  il coefficiente mensile di maturazione dei ratei all’interno della sezione “Maturazione Ratei”. Inoltre, puoi impostare delle autorizzazioni specifiche per il dipendente all’interno della sezione “Ruolo e Autorizzazione”, abilitando i vari permessi cliccando sulla casella corrispondente: le autorizzazioni concesse sono quelle in cui è presente la spunta ✓.
      </div>
      <div className='mb-4'>
        <strong className='text-indigo-800'>Creazione tramite Unilav</strong> 
        <img src={'https://consultalahr.com/wp-content/uploads/2025/01/aggiungi_dipendente_unilav.png'} alt="Aggiungi dipendente unilav" className='my-4 mx-auto w-2/4' />
        Seleziona il formato del file Unilav che desideri caricare, PDF o XML. Dopo il caricamento, inserisci l'email del dipendente per abilitare l'accesso alla piattaforma HR. I dati anagrafici e del contratto<span className='text-indigo-600 font-semibold'>*</span>, presenti nel file Unilav, verranno automaticamente salvati nelle rispettive sezioni. Completa quindi la configurazione della maturazione dei ratei, selezionando il dipendente da Lista Dipendenti e cliccando su “Modifica” e successivamente su “Maturazione ratei”: a quel punto dovrai selezionare il rateo, tra quelli abilitati nella “Configurazione Parametri”, inserire le informazioni richieste e cliccare su “Salva”.
      </div>
      <div>
        <strong className='text-indigo-800'>*Nota sul Contratto:</strong> per la gestione del calendario presenze è necessario che il contratto del dipendente risulti attivo, quindi in corso, e che sia stata effettuata una scelta sulla Tipologia Turno, selezionabile all'interno della tab 'Contratto'.
        <img src={'https://consultalahr.com/wp-content/uploads/2025/01/note_contratto.png'} alt="Note Contratto" className='my-4 mx-auto w-3/4' />
        Le opzioni disponibili sono: 
        <ul className="list-disc ml-5 mt-1">
          <li>Fisso, per dipendenti con turno fisso;</li>
          <li>Turno, per dipendenti turnisti con orario variabile;</li>
          <li>Senza calendario, per dipendenti per i quali non dovranno essere inseriti turni in calendario;</li>
          <li>A chiamata, per dipendenti a cui verranno assegnati turni tramite calendario solo quando necessario.</li>
        </ul>  
      </div>
    </p>
  </div>
);

const ListaDipendenti = () => (
  <div>
    <p className='py-2' style={{ textAlign: 'justify' }}>
      All’interno della “Lista Dipendenti” troverai l’elenco di tutti i dipendenti registrati, da cui potrai visualizzare le loro informazioni principali e il loro stato di Login sull’applicazione “Consultala HR”: puoi filtrarli in base alla loro situazione contrattuale cliccando sulle caselle corrispondenti all’interno della sezione “Visualizza dipendenti”. 
      <img src={'https://consultalahr.com/wp-content/uploads/2025/01/lista_dipendenti.png'} alt="Lista dipendenti" className='my-4 mx-auto w-3/4' />
      Selezionando un dipendente e cliccando su “Apri”, si aprirà una schermata riepilogativa del dipendente in questione, da cui potrai visualizzare tutta la documentazione caricata, lo stato del contratto e dei ratei, i suoi turni, le sue timbrature e i suoi ruoli all’interno dell’azienda. All’interno delle sezioni “Buste Paga”, “Certificazioni Uniche” e “Documenti” puoi caricare i relativi documenti cliccando su “carica nuova”: dovrai quindi inserire le informazioni necessarie richieste e trascinare il pdf del documento in oggetto e, una volta cliccato su “carica”, il dipendente in questione verrà notificato e potrà visualizzarlo.
      Dalla schermata dedicata del singolo dipendente (e dall’elenco dei dipendenti su Lista Dipendenti) puoi inoltre modificare le sue informazioni cliccando su “Modifica” o eliminarlo dal sistema cliccando su “Elimina”.
    </p>
  </div>
);

const CreaUnitaOrganizzativa = () => (
  <div>
    <p className='py-2' style={{ textAlign: 'justify' }}>
      Crea delle unità organizzative al fine di dividere la gestione dei turni e presenze dei tuoi dipendenti, per farlo, clicca su “+ Crea Unità Organizzativa”.
    </p>
    <img src={'https://consultalahr.com/wp-content/uploads/2025/01/crea_unita_organizzativa.png'} alt="Crea Unità Organizzativa" className='my-4 mx-auto w-3/4' />
    <p style={{ textAlign: 'justify' }}>
      Assegna un nome all'unità che stai creando ed aggiungi i dipendenti assegnando loro un ruolo, Gestore o Dipendente. Potrai anche collegare tra loro le unità tramite l'impostazione di appartenenza. I permessi dei dipendenti assegnati all'unità organizzativa dipendono dalle autorizzazioni specifiche impostate su ciascun dipendente (vedi “Aggiungi Dipendente) e dalle autorizzazioni aziendali definite nella configurazione dei parametri.
    </p>
  </div>
);

const GestioneTurni = () => (
  <div>
    <p style={{ textAlign: 'justify' }}>
      Nella sezione di gestione dei turni puoi creare turni e visualizzare i turni esistenti
      <img src={'https://consultalahr.com/wp-content/uploads/2025/01/crea_visualizza_turno_giorno_settimana.png'} alt="Visualizza turno giorno e settimana" className='my-4 mx-auto w-3/4' />
      <div>
        <strong className='text-indigo-800'>Creazione turni:</strong> assegna un nome e crea il <span style={{ textDecoration: 'underline', textDecorationColor: '#4f46e5' }}>turno giornaliero</span>  inserendo l'orario di inizio e fine delle fasce orarie ed eventuali pause. Le pause non verranno conteggiate nell'orario lavorativo. 
        <img src={'https://consultalahr.com/wp-content/uploads/2025/01/crea_turno_giornaliero.png'} alt="Crea Turno Giornaliero" className='my-4 mx-auto w-3/4' />
      </div>
      <div className='pb-4'>
        È inoltre possibile creare il <span style={{ textDecoration: 'underline', textDecorationColor: '#4f46e5' }}>turno settimanale</span> selezionando i giorni di interesse e associando a ciascun giorno un turno giornaliero già creato oppure creando un nuovo turno per il giorno selezionato tramite compilazione del form.
        <img src={'https://consultalahr.com/wp-content/uploads/2025/01/crea_turno_settimana2.png'} alt="Crea Turno Settimanale2" className='my-4 mx-auto w-3/4' />
        Puoi associare il turno settimanale ad un’unità organizzativa nello specifico o impostare “nessuna unità” per rendere il turno disponibile per i dipendenti non appartenenti ad alcuna Unità.
        <img src={'https://consultalahr.com/wp-content/uploads/2025/01/crea_turno_settimana_associa_OU.png'} alt="Crea Turno Settimanale" className='my-4 mx-auto w-3/4' />
      </div>
      <div className='pb-4'>
        <strong className='text-indigo-800'>I miei turni:</strong> visualizza e modifica i turni giornalieri e settimanali che hai creato in precedenza. 
        <img src={'https://consultalahr.com/wp-content/uploads/2025/01/viauslizza_turnio_giornaliero2.png'} alt="Visualizza Turno Giornaliero" className='my-4 mx-auto w-3/4' />
        <hr className='my-4 w-3/4 mx-auto block' />
        <img src={'https://consultalahr.com/wp-content/uploads/2025/01/visualizza_turno_settimanale2.png'} alt="Visualizza Turno Settimanale" className='my-4 mx-auto w-3/4' />
        Se il turno oggetto di modifica è già stato assegnato a un dipendente, la modifica verrà riflessa anche nel calendario del dipendente.
      </div>
    </p>
  </div>
);


const images = [
  { src: 'https://consultalahr.com/wp-content/uploads/2025/01/assegna_turno.png', alt: 'Assegna Turno 1' },
  { src: 'https://consultalahr.com/wp-content/uploads/2025/01/assegna_turno_2.png', alt: 'Assegna Turno 2' },
  { src: 'https://consultalahr.com/wp-content/uploads/2025/01/assegna_turno_3.png', alt: 'Assegna Turno 3' },
  { src: 'https://consultalahr.com/wp-content/uploads/2025/01/assegna_turno_4.png', alt: 'Assegna Turno 4' },
];

const AssegnaTurni = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? images.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const nextSlide = () => {
    const isLastSlide = currentIndex === images.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  return (
    <div>
      <p style={{ textAlign: 'justify' }}>
        Seleziona nella tabella il giorno e il dipendente a cui assegnare il turno, clicca sul simbolo + e scegli tra i turni giornalieri e settimanali già creati o crea un nuovo turno per assegnare l'orario di lavoro.<br />
        Puoi filtrare i dipendenti per la loro unità organizzativa e selezionare la settimana che ti interessa cliccando sulle date poste accanto “Seleziona Settimana”.
        <div className='relative my-4 mx-auto w-full'>
          <div className='overflow-hidden relative'>
            {images.map((image, index) => (
              <div
                key={index}
                className={`${
                  index === currentIndex ? 'block' : 'hidden'
                } duration-700 ease-in-out`}
              >
                <img src={image.src} alt={image.alt} className='w-full' />
              </div>
            ))}
          </div>
          <div className='flex justify-center pt-4'>
            <button
              onClick={prevSlide}
              className='bg-indigo-700 hover:bg-indigo-500 rounded-full p-2 me-4'
            >
              <ChevronLeftIcon className='h-4 w-4 text-white' />
            </button>
   
            <button
              onClick={nextSlide}
              className='bg-indigo-700 hover:bg-indigo-500 rounded-full p-2'
            >
              <ChevronRightIcon className='h-4 w-4 text-white' />
            </button>
          </div>
        </div>
        Per i dipendenti con turno fisso, l'assegnazione dell'orario di lavoro è possibile solo nella sezione anagrafica, selezionando il dipendente dall’elenco del personale in “Lista Dipendenti”: clicca su “Modifica”, in seguito su “Turno di Lavoro” e seleziona il turno da assegnare.
      </p>
    </div>
  );
};

const GestioneGiustificativi = () => (
  <div>
    <p style={{ textAlign: 'justify' }}> Nella sezione <span style={{ textDecoration: 'underline', textDecorationColor: '#4f46e5' }}>Richieste Giustificativi da Gestire</span> puoi approvare o rifiutare le richieste ricevute dai dipendenti, mentre nella sezione <span style={{ textDecoration: 'underline', textDecorationColor: '#4f46e5' }}>Richieste Giustificativi Elaborate</span>  puoi modificarne lo stato impostato in precedenza sulle richieste già gestite o eliminarle.<br />
    <img src={'https://consultalahr.com/wp-content/uploads/2025/01/richiestegiustificativiDaGestire2.png'} alt="Richieste Giustificativi da Gestire" className='my-4 mx-auto w-3/4' />
    <hr className='my-4 w-3/4 mx-auto block' />
    <img src={'https://consultalahr.com/wp-content/uploads/2025/01/richiesteGiustificativiElaborate2.png'} alt="Richieste Giustificativi Elaborate" className='my-4 mx-auto w-3/4' />
    Tramite la sezione <span style={{ textDecoration: 'underline', textDecorationColor: '#4f46e5' }}>Calendario Presenze</span> puoi inoltre inserire nuovi giustificativi, in aggiunta a quelli richiesti dai dipendenti: per farlo, dovrai impostare la vista settimanale o mensile del calendario e cliccare sul simbolo “+” all’interno della giornata che vuoi selezionare, in corrispondenza del dipendente interessato, per aprire una finestra dedicata dove potrai inserire le informazioni necessarie per poter salvare il giustificativo.<br />
    Allo stesso modo, puoi visualizzare all’interno del calendario (sempre con la vista settimanale o mensile) le richieste di giustificativi non ancora elaborate: troverai il segno “-” in corrispondenza della data e del dipendente che ha fatto richiesta e cliccandoci sopra verrai reindirizzato alla pagina di gestione dei giustificativi.
    </p>
    {/* <img src={'/static/images/guida_hr/modifica_giustificativo.png'} alt="Modifica Richiesta Giustificativo" className='my-4 mx-auto w-3/4' /> */}
  </div>
);

const CalendarioPresenze = () => (
  <div>
    <p style={{ textAlign: 'justify' }}>
      Nella sezione del calendario presenze è possibile visualizzare nella stessa tabella le ore di presenza, i giustificativi e le timbrature effettuate, in visualizzazione giornaliera, settimanale o mensile.<br />
      Nella visualizzazione giornaliera, cliccando sulle caselle colorate è possibile visualizzare i dettagli dei turni lavorativi, delle timbrature e degli eventuali giustificativi approvati. Oltre a questo, sia nella visualizzazione settimanale che in quella mensile è possibile impostare dei giustificativi, cliccando sul simbolo “+” in corrispondenza della data e del dipendente interessato, ed è possibile consultare a lato della tabella il calcolo delle ore previste e di quelle effettivamente assegnate per ogni lavoratore: nella visualizzazione mensile viene riportato anche il residuo dei ratei (qualora siano stati impostati ed attivati).
      <img src={'https://consultalahr.com/wp-content/uploads/2025/01/presenze_settimana.png'} alt="Presenze settimana" className='my-4 mx-auto w-full' />
      <hr className='my-4 w-3/4 mx-auto block' />
      Nella visualizzazione mensile, è possibile inoltre esportare il resoconto dei rimborsi spese e la tabella delle presenze effettive dei dipendenti per il mese considerato, in formato excel e .txt.
      <img src={'https://consultalahr.com/wp-content/uploads/2025/01/presenze_mese2.png'} alt="Presenze mese" className='my-4 mx-auto w-full' />
    </p>
  </div>
);

const Avvisi = () => (
  <div>
    <p style={{ textAlign: 'justify' }}>
      Invia messaggi e comunicazioni a tutti i dipendenti dell'azienda, oppure scegli di inviarli a una singola unità organizzativa, a più unità organizzative o a dipendenti selezionati.
      <img src={'https://consultalahr.com/wp-content/uploads/2025/01/avvisi-1.png'} alt="Avvisi img" className='my-4 mx-auto w-3/4' />
      All’interno di questa sezione, trovi anche l’elenco delle comunicazioni inviate in precedenza: cliccando sopra ad uno degli avvisi già inviati, puoi visualizzare anche da quanti dei tuoi dipendenti sia stato effettivamente letto attraverso l’applicazione. Inoltre, cliccando su “notifiche” trovi l’elenco di tutte le notifiche inviate ai dipendenti in riferimento a tutte le varie azioni effettuate sul portale e, anche qui, puoi verificare in tempo reale se siano state visualizzate o meno.
    </p>
  </div>
);

const Timbrature = () => (
  <div>
    <p style={{ textAlign: 'justify' }}>
    <img src={'https://consultalahr.com/wp-content/uploads/2025/01/timbrature.png'} alt="Avvisi img" className='my-4 mx-auto w-3/4' />
    All’interno di questa sezione puoi visualizzare tutte le timbrature di entrata e di uscita effettuate dai tuoi dipendenti, in riferimento al loro orario di lavoro e agli eventuali giustificativi approvati.<br /><br />
    Puoi selezionare la settimana che ti interessa attraverso l’opzione “seleziona settimana” e puoi filtrare i dipendenti tramite l'unità organizzativa, attraverso l’opzione “Seleziona Unità Organizzativa”, oppure cercare un dipendente specifico utilizzando l'apposito campo di ricerca.
    </p>
  </div>
);

const RimborsiSpese = () => (
  <div>
    <p style={{ textAlign: 'justify' }}>
    <img src={'https://consultalahr.com/wp-content/uploads/2025/01/Rimborsi-Spese2.png'} alt="Avvisi img" className='my-4 mx-auto w-3/4' />
      In questa sezione puoi approvare o rifiutare le richieste di rimborso spese inoltrate dai tuoi dipendenti, visualizzando tutti i dettagli di ogni richiesta.<br /><br />
      Nel riepilogo delle richieste gestite trovi invece l’elenco di tutte le richieste già approvate o rifiutate in passato, con il relativo status.<br/><br />
      Puoi anche creare dei rimborsi spese o dei rimborsi chilometrici, senza che un dipendente abbia già fatto richiesta, cliccando sulle relative opzioni a inizio pagina: ti basterà inserire le informazioni richieste e, una volta cliccato “salva”, il rimborso verrà creato e inserito nell’elenco, mentre il  dipendente interessato verrà notificato e potrà visualizzare tutti i dettagli.
    </p>
  </div>
);

const GestioneDocumenti = () => (
  <div>
    <p style={{ textAlign: 'justify' }}>
      <img src={'https://consultalahr.com/wp-content/uploads/2025/01/dettaglio-anagrafica.png'} alt="Avvisi img" className='my-4 mx-auto w-3/4' />
      All’interno delle sezioni “Buste Paga”, “Certificazioni Uniche” e “Documenti” trovi elencati tutti i documenti che hai caricato, suddivisi per mese ed anno: puoi aprirli e visualizzare in tempo reale, per ogni documento, se il dipendente interessato l’ha effettivamente visualizzato.<br /><br />
      Inoltre, puoi effettuare un caricamento massivo dei cedolini o delle certificazioni uniche: per farlo, ti basterà cliccare su “Carica Massivamente”, inserire i dati richiesti, trascinare i pdf dei documenti in oggetto e cliccare su “Carica”. Una volta caricati e confermati, tutti i documenti verranno automaticamente archiviati dal sistema all’interno delle sezioni personali di ogni dipendente. Se è stata selezionata l'opzione di invio notifica in fase di caricamento, il dipendente riceverà una comunicazione relativa al caricamento effettuato.
    </p>
  </div>
);

const AttivazioneApp = () => (
  <div>
    <p style={{ textAlign: 'justify' }}>
      Una volta inserito un dipendente all’interno del portale (Vedi “Aggiungi Dipendente), ti verrà chiesto se vuoi abilitare l’accesso all’app: cliccando su “Sì, abilita ora”, al dipendente verranno inviate automaticamente dal sistema delle credenziali via mail per poter accedere all’Applicazione di Consultala HR.
      L’applicazione di Consultala HR è disponibile per qualsiasi smartphone con sistema operativo Android o iOS e può essere scaricata dallo store di Google Play o dall’App Store: per ricevere le notifiche, è necessario che il dipendente le abiliti dal proprio dispositivo, mentre per effettuare le timbrature geolocalizzate, va consentito l'accesso alla posizione.<br /><br />
      È possibile attivare questa funzione anche in un secondo momento: ti basterà individuare il dipendente a cui vuoi attivare l’accesso nella “Lista Dipendenti”, cliccare su “Modifica” e poi su “Attiva Accesso App”.<br /><br />
      Il dipendente potrà, in qualsiasi momento, consultare le informazioni che lo riguardano, accedendo con le proprie credenziali sia sull’applicazione che sul sito hrconsultala.com da qualsiasi browser.<br /><br />
      N.B. Attivando l’app non sarà possibile per il dipendente effettuare l’accesso in mancanza di un contratto attivo: qualora quest’ultimo non risulti inserito, è possibile impostarlo all’interno della sezione “Contratto” nella pagina di modifica del dipendente, cliccando su “+ Aggiungi Nuovo Contratto”.
    </p>
  </div>
);


export const ManualeUtente = () => {
  const steps = [
    { id: '1', name: 'Configurazione Parametri', icon: AdjustmentsHorizontalIcon },
    { id: '2', name: 'Aggiungi Dipendenti', icon: UserPlusIcon },
    { id: '3', name: 'Lista Dipendenti', icon: UsersIcon },
    { id: '4', name: 'Crea Unità Organizzativa', icon: AcademicCapIcon },
    { id: '5', name: 'Gestione Turni', icon: Cog6ToothIcon },
    { id: '6', name: 'Assegna Turni', icon: BriefcaseIcon },
    { id: '7', name: 'Gestione Giustificativi', icon: ClipboardDocumentCheckIcon },
    { id: '8', name: 'Calendario Presenze', icon: CalendarDaysIcon },
    { id: '9', name: 'Avvisi', icon: SpeakerWaveIcon },
    { id: '10', name: 'Timbrature', icon: ClockIcon },
    { id: '11', name: 'Rimborsi Spese', icon: BanknotesIcon},
    { id: '12', name: 'Gestione Documenti', icon: PaperClipIcon},
    { id: '13', name: 'Attivazione dell\'app per il Dipendente', icon: DevicePhoneMobileIcon},
  ];

  const [currentStep, setCurrentStep] = useState(null);

  const renderContent = () => {
    if (!currentStep) return null;

    const props = { icon: currentStep.icon };
    switch (currentStep.id) {
      case '1':
        return <ConfigurazioneParametri />;
      case '2':
        return <AggiungiDipendenti />;
      case '3':
        return <ListaDipendenti />;
      case '4':
        return <CreaUnitaOrganizzativa />;
      case '5':
        return <GestioneTurni />;
      case '6':
        return <AssegnaTurni />;
      case '7':
        return <GestioneGiustificativi />;
      case '8':
        return <CalendarioPresenze />;
      case '9':
        return <Avvisi />;
      case '10':
        return <Timbrature />;
      case '11':
        return <RimborsiSpese />;
      case '12':
        return <GestioneDocumenti />;
      case '13':
        return <AttivazioneApp />;
      default:
        return '';
    }
  };

  return (
    <div className="min-h-full flex flex-col">
      <header className="bg-indigo-200">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex justify-center my-4">
            <h2 className="text-2xl font-semibold text-indigo-800">Guida Utente</h2>
          </div>
        </div>
      </header>

      <div className="flex flex-1">
        <nav className="w-64 p-4 pt-10 bg-gray-50">
          <ul className="space-y-8">
            {steps.map((step) => (
              <li key={step.id} className="relative flex items-center cursor-pointer" onClick={() => setCurrentStep(step)}>
                <span className={`flex items-center justify-center h-8 w-8 rounded-full ${currentStep?.id === step.id ? 'bg-indigo-600 text-white' : 'border-2 border-gray-300 text-gray-500'} mr-4`}>
                  <span>{step.id}</span>
                </span>
                <span className={`text-sm font-medium ${currentStep?.id === step.id ? 'text-indigo-700' : 'text-gray-900'}`}>{step.name}</span>
              </li>
            ))}
          </ul>
        </nav>
        <main className="flex-1 p-8">
          {currentStep ? (
            <>
              <h3 className="text-xl font-semibold text-indigo-800 mb-4 pt-2"><currentStep.icon className="h-6 w-6 inline-block mr-2" /> {currentStep.name}</h3>
              {renderContent()}
            </>
          ) : (
            <>
              <div className='container border border-dashed border-indigo-700 rounded-md shadow-md md:p-12 p-6 bg-gray-50' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <p className='pt-2 text-md font-medium text-gray-600'>
                  Scegli un argomento dal menu laterale per approfondire le funzionalità.
                </p>
                <p className='pt-2 text-md font-medium text-gray-600'>
                  Per ulteriori necessità di supporto, non esitare a contattarci.
                </p>
              </div>
              <div
                className="mt-8 container border border-dashed border-indigo-700 rounded-md shadow-md md:p-12 p-6 bg-indigo-50"
                style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
              >
                <p className="pt-2 text-md font-medium text-gray-600 justify-center flex">
                  Scopri i nostri video tutorial per orientarti velocemente sul portale di Consultala HR da qui:
                </p>
                <p className="pt-2 text-md font-medium text-gray-600">
                  <a
                    href="https://consultalahr.com/videoguida/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-indigo-600 hover:underline flex"
                  >
                    <OndemandVideoIcon className="text-indigo-600 me-2 mt-0.5 inline-bock" style={{ height: '23px', width: '23px' }} />
                    Video tutorial
                  </a>
                </p>
              </div>
            </>
          )}
        </main>
      </div>
      <div className='pt-8'>
        <Footer />
      </div>
    </div>
  );
};
